// JSON Merge Patch (RFC 7396): objects merge key by key, other values replace, null removes the key.
// Same rules as the PATCH /users/settings endpoint, so local and server results match.
export function applyMergePatch<T>(target: T, patch: unknown): T {
  if (!isPlainObject(patch)) {
    return patch as T;
  }
  const result: Record<string, unknown> = isPlainObject(target) ? { ...target } : {};
  for (const [key, value] of Object.entries(patch)) {
    if (value === null) {
      delete result[key];
    } else {
      result[key] = applyMergePatch(result[key], value);
    }
  }
  return result as T;
}

function isPlainObject(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}

// The merge patch that turns `source` into `target`: changed values, and null for keys that no longer exist
export function createMergePatch(source: unknown, target: unknown): unknown {
  if (!isPlainObject(source) || !isPlainObject(target)) {
    return target;
  }
  const patch: Record<string, unknown> = {};
  for (const key of Object.keys(source)) {
    if (!(key in target)) {
      patch[key] = null;
    }
  }
  for (const [key, value] of Object.entries(target)) {
    if (!(key in source)) {
      patch[key] = value;
    } else if (JSON.stringify(source[key]) !== JSON.stringify(value)) {
      patch[key] = createMergePatch(source[key], value);
    }
  }
  return patch;
}
